import React, { useEffect, useState } from "react";
import regionsData from "@/app/features/company/data/regions_lite.json";
import citiesData from "@/app/features/company/data/cities_lite.json";
import { useLocale } from "@/middleware";
import { useTranslate } from "@/locales";

interface CompanyInfoCardProps {
  company: {
    CompanyNr: string;
    nameAr: string;
    nameEn: string;
    website?: string;
    contactInfo?: string;
    city?: string;
    region?: string;
  };
  OpportunityNr: string;
}
interface City {
  city_id: number;
  region_id: number;
  name_ar: string;
}
interface Region {
  region_id: number;
  name_ar: string;
}
interface Option {
  value: string;
  label: string;
}
const CompanyInfoCard: React.FC<CompanyInfoCardProps> = ({
  company,
  OpportunityNr,
}) => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const [regions, setRegions] = useState<Option[]>([]);
  const [cities, setCities] = useState<Option[]>([]);
  useEffect(() => {
    setRegions(
      regionsData.map((region: Region) => ({
        value: region.region_id.toString(),
        label: region.name_ar,
      }))
    );
  }, []);
  useEffect(() => {
    setCities(
      citiesData.map((City: City) => ({
        value: City.city_id.toString(),
        label: City.name_ar,
      }))
    );
  }, []);
  const getCity = (value: string) => {
    let city = cities.find((item) => parseInt(item.value) === parseInt(value));
    if (city) {
      return city.label;
    } else {
      return "";
    }
  };
  const getRegion = (value: string) => {
    let city = regions.find((item) => parseInt(item.value) === parseInt(value));
    if (city) {
      return city.label;
    } else {
      return "";
    }
  };
  return (
    <div className="mt-4 text-lg md:text-xl grid lg:grid-cols-3 md:gap-6 gap-2">
      <div className="flex gap-2">
        <strong>{t("company.fields.CompanyNr")}:</strong>
        {company.CompanyNr}
      </div>
      <div className="flex gap-2">
        <strong>{t("orders.fields.opportunityNr")}:</strong>
        {OpportunityNr}
      </div>

      <div className={"flex gap-2"}>
        <strong>{t("company.fields.region")}:</strong>
        <>
          {company.city && <div>{getCity(company.city)} - </div>}
          {company.region && <div>{getRegion(company.region)}</div>}
        </>
      </div>
    </div>
  );
};

export default CompanyInfoCard;
